<form [formGroup]="loanProductInterestRefundForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Supported Interest Refund Types' | translate }}</mat-label>
      <mat-select
        multiple
        formControlName="supportedInterestRefundTypes"
        matTooltip="{{
          'tooltips.Refund transactions where interest refund will automatically be calculated' | translate
        }}"
      >
        @for (supportedTransaction of supportedInterestRefundTypesOptions; track supportedTransaction) {
          <mat-option [value]="supportedTransaction.id">
            {{ supportedTransaction.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>
